import { render, staticRenderFns } from "./TemplateGroupsForm.vue?vue&type=template&id=2eabd2e8&scoped=true"
import script from "./TemplateGroupsForm.vue?vue&type=script&lang=js"
export * from "./TemplateGroupsForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateGroupsForm.vue?vue&type=style&index=0&id=2eabd2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eabd2e8",
  null
  
)

export default component.exports